import { render, staticRenderFns } from "./Age.vue?vue&type=template&id=8167f102&"
import script from "./Age.vue?vue&type=script&lang=js&"
export * from "./Age.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8167f102')) {
      api.createRecord('8167f102', component.options)
    } else {
      api.reload('8167f102', component.options)
    }
    module.hot.accept("./Age.vue?vue&type=template&id=8167f102&", function () {
      api.rerender('8167f102', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Age.vue"
export default component.exports